export enum PlayerChemistry {
    SUCCESS = 'success',
    WARNING = 'warn',
    DANGER = 'danger'
}